import { useEffect } from 'react';

const FreshdeskWidget = () => {
  // Load the Freshdesk widget script immediately
  useEffect(() => {
    // Configure Freshdesk widget settings
    window.fwSettings = {
      'widget_id': 153000001469
    };

    // Create and append the script
    const script = document.createElement('script');
    script.src = 'https://widget.freshworks.com/widgets/153000001469.js';
    script.async = true;
    document.body.appendChild(script);

    // Cleanup function to remove the script when component unmounts
    return () => {
      const script = document.querySelector('script[src="https://widget.freshworks.com/widgets/153000001469.js"]');
      if (script) document.body.removeChild(script);
    };
  }, []);

  // No visible UI - the Freshdesk widget will show its own UI
  return null;
};

export default FreshdeskWidget;
